/** GXL staff: a @gxl.ai account. Pages use it to show "staff only"; the backend
 * also requires a verified email, so this alone grants nothing. */
export const isStaff = (email: string | null | undefined): boolean =>
  !!email && email.trim().toLowerCase().endsWith("@gxl.ai");
